import { useTranslation } from "react-i18next";
import PolicyPageLayout, {
  PolicySection,
} from "../shared/components/PolicyPageLayout";

const PrivacyPolicy = () => {
  const { t } = useTranslation("home");

  return (
    <PolicyPageLayout title={t("privacyPolicy.title")}>
      <PolicySection>{t("privacyPolicy.generalRule")}</PolicySection>
      <PolicySection title={t("privacyPolicy.siteVisitData.title")}>
        {t("privacyPolicy.siteVisitData.content")}
      </PolicySection>
      <PolicySection>
        {t("privacyPolicy.siteVisitData.lawEnforcement")}
      </PolicySection>
      <PolicySection title={t("privacyPolicy.cookies.title")}>
        {t("privacyPolicy.cookies.content")}
      </PolicySection>
      <PolicySection title={t("privacyPolicy.emailManagement.title")}>
        {t("privacyPolicy.emailManagement.content")}
      </PolicySection>
      <PolicySection title={t("privacyPolicy.personalInfo.title")}>
        {t("privacyPolicy.personalInfo.content")}
      </PolicySection>
      <PolicySection title={t("privacyPolicy.note.title")}>
        {t("privacyPolicy.note.content")}
      </PolicySection>
    </PolicyPageLayout>
  );
};

export default PrivacyPolicy;
